import { createContext } from 'react';

export const AnimateIconBaseContext = createContext<number>(0);
